// extracted by extract-css-chunks-webpack-plugin
module.exports = {"_sharedGrid":"swipeCarousel___sharedGrid--B24Iu","reactIdSwiper":"swipeCarousel__reactIdSwiper--1cnPV"};